import React, { Component } from "react";
import axios from "axios";
import MetricsIcon from "../../assets/MetricsIcon.png";
import CryptoJS from "crypto-js";
import config from "../../config/authConfig.js";

class Metrics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      WeeklyReportData: [],
      MonthlyReportData: [],
      result: null,
      filename: "",
      isAdmin: false,
      windowheight: 0,
      isLoaded: false,
    };
  }
  async componentDidMount() {
    var lsWWID_dec = "1461636";
    if (process.env.REACT_APP_WORKDAY_LOCAL_DEBUG != "Yes") {
      // const secretKeyforEncryption = config.encryptionkey;
      // const aliasWWIDName = config.aliasWWIDName;
      // var lsWWID = sessionStorage.getItem(aliasWWIDName);
      // var lsWWID_dec_bytes = CryptoJS.AES.decrypt(lsWWID, secretKeyforEncryption);
      // lsWWID_dec = JSON.parse(lsWWID_dec_bytes.toString(CryptoJS.enc.Utf8));
      const secretKeyforEncryption = config.encryptionkey;
      var lsWWID = localStorage.getItem("wwid");
      var lsWWID_dec_bytes = CryptoJS.AES.decrypt(
        lsWWID,
        secretKeyforEncryption
      );
      var lsWWID_dec = JSON.parse(lsWWID_dec_bytes.toString(CryptoJS.enc.Utf8)); //this will decrypt the encrypted value.
    }
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    await axios({
      method: "GET",
      url: process.env.REACT_APP_WORKDAY_API_URL + "getMetricsReports",
      headers: {
        apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
        clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.setState({
          WeeklyReportData: res.data.metricsReports[0].reportList,
          MonthlyReportData: res.data.metricsReports[1].reportList,
        });
      })
      .catch((error) => {
        //on error
        // alert("There is an error in API call.");
      });
    await axios({
      method: "POST",
      url: process.env.REACT_APP_WORKDAY_API_URL + "isAdmin",
      headers: {
        apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
        clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
        "Content-Type": "application/json",
      },
      data: { userWWID: lsWWID_dec },
      //data: { "userWWID": "643029835" }
    })
      .then((res) => {
        this.setState({
          isLoaded: true,
          isAdmin: res.data.isAdmin,
        });
      })
      .catch((error) => {
        //on error
        // alert("There is an error in API call.");
      });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({
      windowheight:
        window.innerHeight -
        this.Dimension("headercontent") -
        this.Dimension("footercontent"),
    });
  };
  Dimension = (elmID) => {
    var elmHeight,
      elmMargin,
      elm = document.getElementsByClassName(elmID)[0];
    if (document.all) {
      // IE
      elmHeight = elm.clientHeight;
      elmMargin =
        parseInt(elm.currentStyle.marginTop, 10) +
        parseInt(elm.currentStyle.marginBottom, 10);
    } else {
      // Mozilla
      elmHeight = elm.clientHeight;
      elmMargin =
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-top")
        ) +
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-bottom")
        );
    }
    return elmHeight + elmMargin + 6;
  };
  getweeklyreport = (weeklyreport) => {
    if (weeklyreport.length > 0) {
      return weeklyreport.map((items) => (
        <div
          className="weeklyReport"
          id={items.reportId}
          onClick={(e) => {
            this.DownloadReport(items.reportId, items.reportName);
          }}
        >
          <img src={MetricsIcon} alt="Smiley face"></img>
          <p key={items.reportId}>{items.reportName}</p>
        </div>
      ));
    }
  };
  getmonthlyreport = (monthlyreport) => {
    if (monthlyreport.length > 0) {
      return monthlyreport.map((items) => (
        <div
          className="monthlyReport"
          id={items.reportId}
          onClick={(e) => {
            this.DownloadReport(items.reportId, items.reportName);
          }}
        >
          <img src={MetricsIcon} alt="Smiley face"></img>
          <p key={items.reportId}>{items.reportName}</p>
        </div>
      ));
    }
  };
  DownloadReport = (reportId, reportname) => {
    this.setState({ filename: reportname });
    axios({
      method: "POST",
      url: process.env.REACT_APP_WORKDAY_API_URL + "downloadReport",
      headers: {
        apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
        clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
        "Content-Type": "application/json",
      },
      data: {
        reportId: reportId,
        reportName: reportname,
      },
    }).then((response) => {
      const type = response.headers["content-type"];
      const blob = new Blob([response.data], { type: type, encoding: "UTF-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = this.state.filename;
      link.click();
    });
  };
  render() {
    return (
      <div
        className="reportwrapper"
        style={{ minHeight: +this.state.windowheight }}
      >
        {this.state.isLoaded === true ? (
          <div>
            {this.state.isAdmin === true ? (
              <div>
                <div className="monthlywrapper">
                  <div className="weeklyreportheader">
                    <h4>Weekly Report</h4>
                  </div>
                  <div className="monthlyinnerwrapper">
                    {this.getweeklyreport(this.state.WeeklyReportData)}
                  </div>
                </div>
                <div className="monthlywrapper">
                  <div className="monthlyreportheader">
                    <h4>Monthly Report</h4>
                  </div>
                  <div className="monthlyinnerwrapper">
                    {this.getmonthlyreport(this.state.MonthlyReportData)}
                  </div>
                </div>
              </div>
            ) : (
              <div className="unauthorizedview">
                <div className="unauthpara">
                  <p>You are not authorized to view this page</p>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="dataLoader">Loading data please wait...</div>
        )}
      </div>
    );
  }
}
export default Metrics;
